import styled from "styled-components";
import FileIconSvg from "core/icons/file/file-alt.svg?react";
import LinkIconSvg from "core/icons/link/link.svg?react";
import YoutubeIconSvg from "core/icons/Socmed/youtube.svg?react";

export const Container = styled.div`
  display: flex;
  width: fit-content;
  align-items: center;
  flex-wrap: nowrap;
  max-width: 250px;
  min-width: 150px;
  padding: 0px 16px;
  height: 32px;
  background-color: ${({ theme }) => theme?.colors?.white};
  border: 1px solid ${({ theme }) => theme?.colors?.gray.gray10};
  border-radius: 8px;
  margin-right: 8px;
  margin-bottom: 8px;
`;

export const FileIcon = styled(FileIconSvg)`
  margin-right: 8px;
`;

export const LinkIcon = styled(LinkIconSvg)`
  margin-right: 8px;
`;

export const YoutubeIcon = styled(YoutubeIconSvg)`
  margin-right: 8px;
`;

export const Text = styled.p`
  color: ${({ theme }) => theme?.colors?.neutral.neutral90};
  white-space: nowrap;
`;

export const Link = styled.a`
  color: ${({ theme }) => theme?.colors?.neutral.neutral90};
  white-space: nowrap;
`;
